import {
  Box,
  Button,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import useFetch from "../../hooks/useFetch";
import { orderhistory_api } from "../../api/urls";
import { api } from "../../api/api";
import { toast } from "react-toastify";
import { ChevronLeft } from "lucide-react";
import { Checkbox } from "@mui/material";

const ReturnReplace = ({
  orderData,
  orderID,
  pageTitle,
  additionalComments,
  setAdditionalComments,
  isReturn,
  isReplace,
  cancelReason,
  setCancelReason,
  setIsReturn,
  setStep,
  onNext,
  uploadedImage,
  setUploadedImage,
  setIsReplace,
  setSelectedQty,
  selectedQty,
}) => {
  const endPoint = isReplace
    ? "replaceproduct"
    : isReturn
      ? "returnproduct"
      : null;
  const { data, loading: reasonLoading } = useFetch(
    endPoint && orderhistory_api + `${orderID}/${endPoint}/`,
  );
  const [isAccept, setIsAccept] = useState(false);
  const [loading, setLoading] = useState(false);
  const [agree, setAgree] = useState(false);

  const replacePayload = {
    user_check: true,
    reason_choices: cancelReason,
    reason_comment: additionalComments,
    cart_id: orderID,
    def: uploadedImage,
    quantity: selectedQty,
  };

  const handleContinue = async () => {
    try {
      setLoading(true);

      if (isReplace) {
        await api.patch(
          orderhistory_api + `${orderID}/replaceproduct/`,
          replacePayload,
        );
        setStep(3);
      }
      if (isReturn) {
        setStep(2);
      }
    } catch (error) {
      toast.error(error.response?.data?.data || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };
  const handleQtyChange = (event) => {
    setSelectedQty(event.target.value);
  };

  return (
    <div>
      <button
        onClick={() => {
          if (isReturn) {
            setIsReturn(false);
          } else if (isReplace) {
            setIsReplace(false);
          }
        }}
        className="text-sm mt-2 flex items-center gap-1 text-gray-400"
      >
        <ChevronLeft size={20} /> Back
      </button>
      <h4 className="my-2 text-2xl">{pageTitle} Item</h4>
      <Box sx={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
        <div className="w-[150px] h-[150px] rounded-lg">
          <img
            src={orderData?.tagon_product_image}
            alt="Product"
            className="object-cover rounded-lg w-[150px] h-[150px]"
          />
        </div>
        <div>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <p>
              Order ID:
              <span className="text-orange-600"> #{orderID}</span>
            </p>
            <p className="capitalize">{orderData?.product_title}</p>

            <div className="flex gap-2 items-center">
              Qty :{/* {orderData?.quantity} */}
              <Select
                displayEmpty
                value={selectedQty || ""}
                onChange={handleQtyChange}
                sx={{
                  "& .MuiSelect-select": {
                    padding: "5px 10px",
                  },
                }}
              >
                {Array.from({ length: orderData?.quantity }).map((_, i) => (
                  <MenuItem key={i} value={i + 1} sx={{ fontSize: "13px" }}>
                    {i + 1}
                  </MenuItem>
                ))}
              </Select>
            </div>

            <p>
              ₹ {Number(orderData?.total_amount_paid_amt || 0).toFixed(2)}/-
            </p>
          </Box>
        </div>
      </Box>
      <div className="my-3">
        <Typography fontSize="18px">Reason for {pageTitle}</Typography>
        <Typography style={{ color: "gray" }}>
          Please tell us correct reason for {pageTitle}. This information is
          only used to improve our service
        </Typography>
      </div>
      {/* Radio group */}
      <h4 className="text-lg">Select Reason*</h4>
      <RadioGroup
        value={cancelReason}
        onChange={(e) => {
          setCancelReason(e.target.value);
          setIsAccept(e.target.name === "true"); // ✅ FIXED
        }}
      >
        {reasonLoading ? (
          <div>
            <div className="mt-2 space-y-4">
              <div className="h-5 w-2/5 bg-gray-300 animate-pulse rounded" />
              <div className="h-5 w-2/5 bg-gray-300 animate-pulse rounded" />
              <div className="h-5 w-2/5 bg-gray-300 animate-pulse rounded" />
              <div className="h-5 w-2/5 bg-gray-300 animate-pulse rounded" />
            </div>
          </div>
        ) : (
          data?.questions.map(({ question, id, accept }, i) => (
            <React.Fragment key={id}>
              <FormControlLabel
                value={question}
                control={<Radio />}
                label={question}
                name={String(accept)}
              />
              {!accept && cancelReason === question && (
                <Typography variant="body2" style={{ color: "red" }}>
                  This reason is not acceptable
                </Typography>
              )}
            </React.Fragment>
          ))
        )}
      </RadioGroup>
      <h4 className="text-lg my-2">Upload Image*</h4>
      <ImageUpload
        uploadedImage={uploadedImage}
        setUploadedImage={setUploadedImage}
      />
      <h4 className="text-lg mb-2">Additional Comments</h4>
      <TextField
        placeholder="Description"
        value={additionalComments}
        onChange={(e) => {
          setAdditionalComments(e.target.value);
        }}
        fullWidth
        multiline
        minRows={3}
        variant="outlined"
        sx={{ mb: 2 }}
      />
      <Box
        sx={{
          display: "flex",
          gap: "5px",
          flexWrap: "wrap",
          alignItems: "center",
        }}
      >
        <Checkbox
          onChange={() => setAgree((prev) => !prev)}
          size="small"
          color="primary"
          checked={agree}
        />
        <InputLabel>
          {" "}
          I confirm that the product is unused with the original tags intact
        </InputLabel>
      </Box>
      <div className="flex justify-end p-2 pb-10">
        <button
          onClick={handleContinue}
          disabled={
            loading ||
            !agree ||
            !cancelReason ||
            !uploadedImage ||
            !isAccept === "true"
          }
          className="disabled:bg-slate-200 disabled:text-slate-400 p-2 rounded-md cursor-pointer border px-5 hover:bg-black hover:text-white transition-all"
        >
          Continue
        </button>
      </div>
    </div>
  );
};
const ImageUpload = ({ uploadedImage, setUploadedImage }) => {
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedImage(file);
    }
  };

  return (
    <Box display="flex" flexDirection="column" gap={1} sx={{ mb: 2 }}>
      <Box display="flex" alignItems="center" gap={2}>
        <Button
          variant="contained"
          component="label"
          sx={{
            backgroundColor: "#fff",
            color: "#000",
            border: "1px solid #ccc",
            textTransform: "none",
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "#f5f5f5",
              boxShadow: "none",
            },
          }}
        >
          Choose File
          <input
            id="upload-image"
            type="file"
            hidden
            accept="image/*"
            onChange={handleFileChange}
          />
        </Button>
        <Typography
          color="text.secondary"
          style={{
            border: "1px solid lightgray",
            padding: "5px 15px",
            borderRadius: "4px",
          }}
        >
          {uploadedImage ? uploadedImage.name : "No Chosen File"}
        </Typography>
      </Box>
    </Box>
  );
};

export default ReturnReplace;
